import React, { useEffect } from "react";
// import Logo from "../../assets/svg/Logo.svg";
import ArrowLeft from "../../assets/svg/ArrowLeft.svg";
import NextLink from 'next/link'
import styles from "./SignInForm.module.css";
// import {Notice} from "../common/Notice";
import {Title} from "../common/Title";
// import {Input} from "../common/Input";
import {useSignIn} from "@clerk/nextjs";
import {useRouter} from "next/router";
import {useForm} from "react-hook-form";
// import {Button} from "../common/Button";
import {APIResponseError, parseError} from "../utils/errors";
import {SignInCode} from "./SignInCode";
import {Validations} from "../utils/formValidations";
import {SignInPassword} from "./SignInPassword";
// import {VerificationSwitcher} from "./VerificationSwitcher";
import {EmailCodeFactor} from "@clerk/types";
import {
  Box,
  Stack,
  Button,
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Flex,
  Link,
  Text,
  Heading
} from '@chakra-ui/react';

interface SignInInputs {
  emailAddress: string;
}

export enum SignInFormSteps {
  EMAIL,
  PASSWORD,
  CODE,
}

export function SignInForm() {
  const {isLoaded, signIn, setSession} = useSignIn();
  const router = useRouter();
  const [firstName, setFirstName] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const [formStep, setFormStep] = React.useState(SignInFormSteps.EMAIL);
  const {
    register,
    handleSubmit,
    setError,
    getValues,
    formState: { errors },
  } = useForm<SignInInputs>();

  if(!isLoaded) {
    return null;
  }

  useEffect(() => {
    formStep == 2 && sendSignInCode();
    
  }, [formStep])

  const sendSignInCode = async function () {
    const emailAddress = getValues("emailAddress");
    const signInAttempt = await signIn.create({
      identifier: emailAddress,
    });

    const emailCodeFactor = signInAttempt.supportedFirstFactors.find(
      (factor) => factor.strategy === "email_code"
    ) as EmailCodeFactor;

    setFirstName(signInAttempt.userData.firstName || "");
    await signInAttempt.prepareFirstFactor({
      strategy: "email_code",
      emailAddressId: emailCodeFactor.emailAddressId,
    });
  };

  const verifyEmail = async function () {
    try {
      setIsLoading(true);
      const emailAddress = getValues("emailAddress");
      const signInAttempt = await signIn.create({
        identifier: emailAddress,
      });
      
      setFormStep(SignInFormSteps.PASSWORD);
      
    } catch (err) {
      setError("emailAddress", {
        type: "manual",
        message: parseError(err as APIResponseError),
      });
    } finally {
      setIsLoading(false);
    }
  };

  const signUpComplete = async (createdSessionId: string) => {
    /** Couldn't the signin be updated and have the createdSessionId ? */
    setSession(createdSessionId, () => router.push("/dashboard"));
  };

  return (
    <div>
      {/* {formStep !== SignInFormSteps.EMAIL && (
        <BackButton onClick={() => setFormStep(SignInFormSteps.EMAIL)} />
      )} */}
      {/* <div>
        <Logo fill={"var(--color-primary)"} />
      </div> */}
      {/* <Title
        content={"Sign in to your account"}
        subtitle={`Welcome back ${firstName}`}
      /> */}
      {formStep === SignInFormSteps.EMAIL && (
        <form onSubmit={handleSubmit(verifyEmail)}>
          <Stack spacing="5">
          <Box>
          <Text fontSize="sm">Email: demo@biocodify.com</Text>
          <br/>
          <FormControl isInvalid={errors.emailAddress}>
          <FormLabel htmlFor='email' fontSize="sm">Email address</FormLabel>
          <Input
            label="Email"
            {...register("emailAddress", Validations.emailAddress)}
            errorText={errors.emailAddress?.message}
            autoFocus
          />
          {errors.emailAddress && <FormErrorMessage>{errors.emailAddress.message}</FormErrorMessage>}
          </FormControl>
          </Box>
          {/* <div className={styles.actionButton}> */}
            <Button size="md" fontSize="sm" minW='100%' type="submit" isLoading={isLoading}>Continue</Button>
            </Stack>
          {/* </div> */}
          {/* <Notice
            content="Don’t have an account?"
            actionLink="/sign-up"
            actionMessage="Sign up"
          /> */}
        </form>
      )}
      {formStep === SignInFormSteps.PASSWORD && (
        <SignInPassword onDone={signUpComplete} />
      )}
      {formStep === SignInFormSteps.CODE && (
        <SignInCode
          onDone={signUpComplete}
          emailAddress={getValues("emailAddress")}
        />
      )}
      {/* <br></br>
      <VerificationSwitcher
        formStep={formStep}
        onSwitchVerificationMethod={setFormStep}
      /> */}
      {/* <Box mt="5" textAlign={'center'} fontSize="sm">
          <NextLink href='/signup' passHref>
          <Link>Don't have an account? Sign up</Link>
          </NextLink>
        </Box> */}
    </div>
  );
}

type BackButtonProps = { onClick: () => void };
function BackButton({ onClick }: BackButtonProps): JSX.Element {
  return (
    <div>
      <button className={styles.backLink} onClick={onClick}>
        <ArrowLeft /> Back
      </button>
    </div>
  );
}
